import { effect, signal } from "alien-signals";
import {
	deleteBookmark,
	getBookmarks,
	initBookmarks,
	locatorExists,
	saveBookmark,
} from "../models/AnnotationService.js";
import { bookmarksHandler, locale, loggedIn } from "./app-signals.js";
import { fetchRetry } from "../models/trackerUtilities.js";
import { showToast } from "../views/ui-elements/cassis-toast.js";
import { locales } from "../models/locales.js";

export const localFetch = signal(fetchRetry);

export const bookmarksList = signal([]);

effect(async () => {
	const initialLocators = await init(bookmarksHandler(), loggedIn());
	bookmarksList(initialLocators);
});

export async function saveBookmarkLocator(locator) {
	if (!locatorExists(locator)) {
		const saved = saveBookmark(locator);
		bookmarksList(getBookmarks());
		showToast(locales.bookmarkSaved[locale()]);
		await saveRemoteBookmark(locator);
		return saved;
	}
}

export async function deleteBookmarkLocator(locator) {
	const deleted = deleteBookmark(locator);
	bookmarksList(getBookmarks());
	showToast(locales.bookmarkDeleted[locale()]);
	const route = bookmarksHandler();
	const logged = loggedIn();
	if (route && logged) {
		const uuid = locator.id;
		const splitRoute = route.split("?")[0];
		const fetchRetry = localFetch();
		await fetchRetry(`${splitRoute}/${uuid}`, {
			method: "DELETE",
			credentials: "same-origin",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
		}).catch(() => {});
	}
	return deleted;
}

async function saveRemoteBookmark(locator) {
	const route = bookmarksHandler();
	const logged = loggedIn();

	if (route && logged) {
		const body = JSON.stringify({
			bookmark: locator,
		});
		const fetchRetry = localFetch();
		await fetchRetry(route, {
			method: "POST",
			body: body,
			credentials: "same-origin",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
		}).catch(() => {});
	}
}

export async function init(route, loggedIn) {
	if (route && loggedIn) {
		try {
			const fetchRetry = localFetch();
			const response = await fetchRetry(route, {
				method: "GET",
				credentials: "same-origin",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
				},
			});

			let initialLocators = [];
			if (response.ok) {
				initialLocators = await response.json();
			} else {
				initialLocators = getBookmarks();
			}
			bookmarksList(initialLocators);
			return initBookmarks(initialLocators);
		} catch (_err) {
			console.error(_err);
			const initialList = getBookmarks();
			if (initialList) {
				bookmarksList(initialList);
				return initialList;
			}
		}
	} else {
		const initialList = getBookmarks();
		if (initialList) {
			bookmarksList(initialList);
			return initialList;
		}
	}
}
